import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import emptyCart from 'assets/empty-cart.svg';
import cartMini from 'assets/cart-mini.svg';

const ShoppingCartEmpty = () => {
  return (
    <>
      <Col lg={9} className="text-center">
        <h2 className="text-tangaroa">Tu carrito está vacío</h2>
        <img src={emptyCart} alt="shopping-cart-empty" />
        <p className="py-30 text-tangaroa">
          Haz clic en el botón de ‘Navegar’ para buscar nuevas Experiencias.
        </p>
        <Link to="/" className="btn btn-primary">Navegar</Link>
      </Col>
      <Col lg={3}>
        <div className="bg-color-westar p-15 mt-30 mt-lg-0 overlap-gray text-tangaroa">
          <img src={cartMini} alt="shopping-cart-icon" className="py-15" />
          <h3>Resumen de tu pedido</h3>
          <p>Aún no tienes seleccionado ningún campo</p>
        </div>
      </Col>
    </>
  );
};

export default ShoppingCartEmpty;
